import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref } from 'vue';
import {
  BaseForm,
  BaseButton,
  BaseTextContent,
  XrkMessage,
  BaseDialog,
  BaseFormItem,
  BaseDatePicker
} from 'xrk-components';
import { updateExpiraAt } from '../../data-source/apis';
import { formatter } from '@/utils';
import { useDateFormat } from '@vueuse/core';


export default /*#__PURE__*/_defineComponent({
  __name: 'add-time-dialog',
  props: {
    remove: {},
    id: {},
    registerAt: {},
    expiraEnd: {},
    historyExpiraDateList: {}
  },
  emits: ['success'],
  setup(__props: any, { emit: __emit }) {

const emits = __emit;
const props = __props;

const formRef = ref();
const formData = ref({
  expira:
    !props.expiraEnd && props.registerAt
      ? [
          props.registerAt,
          useDateFormat(
            new Date(
              new Date(props.registerAt).getTime() +
                (365 - 1) * 24 * 60 * 60 * 1000
            ),
            'YYYY-MM-DD'
          ).value
        ]
      : []
});

const disabledDate = date => {
  // 未设置过则不限制
  if (!props.expiraEnd) {
    return false;
  }
  const historyExpiraDateList = props.historyExpiraDateList;
  const curTime = date.getTime();
  // 可选范围为 大于最大日期的结束时间
  const lastTime = new Date(
    historyExpiraDateList?.length
      ? historyExpiraDateList[0].endAt
      : props.expiraEnd
  ).getTime();
  return curTime <= lastTime;
};
const onCancel = () => {
  props.remove();
};

const onConfirm = async () => {
  await formRef.value.validate();
  await updateExpiraAt({
    id: props.id,
    expiraStart: formatter.date(formData.value.expira[0], 'YYYY-MM-DD'),
    expiraEnd: formatter.date(formData.value.expira[1], 'YYYY-MM-DD')
  });
  XrkMessage.success('操作成功');
  emits('success');
  onCancel();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(BaseDialog), {
    width: "550px",
    title: "新增延期时间",
    "model-value": true,
    "show-close": true,
    "close-on-press-escape": true,
    "close-on-click-modal": false
  }, {
    footer: _withCtx(() => [
      _createVNode(_unref(BaseButton), {
        type: "default",
        onClick: onCancel
      }, {
        default: _withCtx(() => [
          _createTextVNode("取消")
        ]),
        _: 1
      }),
      _createVNode(_unref(BaseButton), {
        type: "primary",
        click: onConfirm
      }, {
        default: _withCtx(() => [
          _createTextVNode("保存")
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createVNode(_unref(BaseTextContent), null, {
        default: _withCtx(() => [
          _createVNode(_unref(BaseForm), {
            ref_key: "formRef",
            ref: formRef,
            "label-position": "top",
            model: formData.value
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(BaseFormItem), {
                label: "服务有效期",
                prop: "expira",
                rules: [{ required: true, message: '请选择', trigger: 'change' }]
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(BaseDatePicker), {
                    style: {"width":"100%"},
                    type: "daterange",
                    placeholder: "请选择",
                    "validate-event": "",
                    disabledDate: disabledDate,
                    modelValue: formData.value.expira,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.expira) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})